import * as React from 'react'

const SvgLightFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.375 1.25h1.25v3.1h-1.25v-3.1zm4.18 4.306l2.191-2.191.884.884-2.192 2.192-.884-.885zm2.095 3.819h3.1v1.25h-3.1v-1.25zm-2.092 5.065l.884-.884 2.192 2.192-.884.883-2.192-2.191zm-4.183 1.21h1.25v3.1h-1.25v-3.1zm-6.002.101l2.192-2.192.884.884-2.192 2.192-.884-.884zM1.25 9.375h3.1v1.25h-3.1v-1.25zm2.119-5.123l.884-.884L6.445 5.56l-.884.884L3.37 4.252zM10 6.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgLightFilledIcon
